export default __webpack_public_path__ + "static/media/71_desktop.1329270d.jpg";